export default __webpack_public_path__ + "static/media/achievements.9104b24d.png";